module.exports = __webpack_public_path__ + "static/img/banner.7e907fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/productCenter/A3/banner.png
// module id = LoNy
// module chunks = 0